/** @format */

import { CreditApplyResponse } from '@my-account/data-access/interfaces';
import { Environment } from '@shared/data-access/interfaces';
import { HttpService } from '@shared/data-access/services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CreditService {
	constructor(
		private httpService: HttpService,
		private environment: Environment
	) {}

	public getCreditApplyUri(): Observable<CreditApplyResponse> {
		const url = `${this.environment.baseUrls.creditApi}/v1/creditapply`;

		const httpOptions = {
			withCredentials: true
		};

		return this.getWithDefaultHeaders(url, 0, httpOptions);
	}

	public getCreditApplyRedirectURI(
		params,
		isPrequalifying = false
	): Observable<CreditApplyResponse> {
		const applicationType = isPrequalifying ? 'PREQUAL' : 'APPLY';
		const url = `${this.environment.baseUrls.creditApi}/v1/creditapply/redirect/${applicationType}`;

		const httpOptions = {
			withCredentials: true,
			params: params
		};

		return this.getWithDefaultHeaders(url, 0, httpOptions);
	}

	public getWithDefaultHeaders<T>(
		url: string,
		retries = 0,
		httpOptions: object = {}
	): Observable<T> {
		httpOptions = this.setDefaultHeaders(httpOptions);

		return this.httpService.get<T>(url, retries, httpOptions);
	}

	public setDefaultHeaders(httpOptions: object = {}): object {
		if (httpOptions['headers'] === undefined) {
			httpOptions['headers'] = {};
		}

		httpOptions['headers']['partner_key'] = this.environment.creditServiceKey.partnerKey;
		httpOptions['headers']['secret_key'] = this.environment.creditServiceKey.secretKey;

		return httpOptions;
	}
}
